/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments200,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
} from "../../types/courseRegistrationDocumentController/GetApiV1CourseregistrationDocumentCourseregistrationidAttachments.ts";
import { courseRegistrationManagementAttachmentGroupViewModelSchema } from "../courseRegistrationManagementAttachmentGroupViewModelSchema.ts";

export const getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationDocumentCourseregistrationidAttachments200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementAttachmentGroupViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachments200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationDocumentCourseregistrationidAttachments400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationDocumentCourseregistrationidAttachments401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationDocumentCourseregistrationidAttachments500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500>;

export const getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationDocumentCourseregistrationidAttachments200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse>;
